<template>
	<div>
		<div class="x-stat">
			<a-row>
				<a-col :span="3">
					<a-statistic title="数量" :value="totalRow" />
				</a-col>
			</a-row>
		</div>

		<a-card :bordered="false">
			<div class="x-filter">
				<a-form layout="inline">
					<a-row :gutter="24">
						<a-col :span="4">
							<a-form-item label="用户">
								<a-input v-model="queryParams.user" placeholder="ID/昵称" />
							</a-form-item>
						</a-col>
						<a-col :span="4">
							<a-form-item label="支付类型">
								<a-select v-model="queryParams.transferType" placeholder="请选择" allow-clear>
									<a-select-option value="ALIPAY">支付宝</a-select-option>
									<a-select-option value="WECHAT">微信</a-select-option>
								</a-select>
							</a-form-item>
						</a-col>
						<a-col :span="4">
							<a-form-item label="状态">
								<a-select v-model="queryParams.status" placeholder="请选择" allow-clear>
									<a-select-option value="WAIT">待处理</a-select-option>
									<a-select-option value="PAID">已支付</a-select-option>
									<a-select-option value="REFUSE">已拒绝</a-select-option>
								</a-select>
							</a-form-item>
						</a-col>
						<template v-if="advanced">
							<a-col :span="6">
								<a-form-item label="转账单号">
									<a-input v-model="queryParams.transferNo" placeholder="转账单号" />
								</a-form-item>
							</a-col>
							<a-col :md="8">
								<a-form-item label="时间">
									<a-range-picker @change="onCreateTime" v-model="createTime" style="width:100%" />
								</a-form-item>
							</a-col>
						</template>
						<a-col :span="!advanced && 4 || 24">
							<span
								class="x-filter-submit-box"
								:style="advanced && { float: 'right', overflow: 'hidden' } || {}"
							>
								<a-button type="primary" @click="fetchTableData">查询</a-button>
								<a-button style="margin-left:8px" @click="rest">重置</a-button>
								<a @click="toggleAdvanced" style="margin-left: 8px">
									{{ advanced ? '收起' : '展开' }}
									<a-icon :type="advanced ? 'up' : 'down'" />
								</a>
							</span>
						</a-col>
					</a-row>
				</a-form>
			</div>

			<a-table
				:rowKey="record => record.id"
				:columns="tableColumns"
				:loading="tableLoading"
				:dataSource="tableData"
				:pagination="false"
			>
				<template slot="transferType" slot-scope="record">
					<span v-if="record.transferType === 'ALIPAY'">支付宝</span>
					<span v-else-if="record.transferType === 'WECHAT'">微信</span>
					<span v-else>{{ record.transferType }}</span>
				</template>

				<template slot="user" slot-scope="record">
					<div class="user" v-if="record.userId">
						<div class="user-left">
							<img class="cover-img" :src="record.avatarUrl || ''" width="48" height="48" alt="" @click="openUserDetail(record.userId)" />
						</div>
						<div class="user-right">
							<p class="first">
								<span class="nickname">{{ record.nickname }}</span>
							</p>
							<p class="row">
								<span class="user-right-detail" v-if="record.sex === 'MALE'">男</span>
								<span class="user-right-detail" v-else-if="record.sex === 'FEMALE'">女</span>
								<span class="user-right-detail" v-if="record.age != null && record.age !== ''">{{ record.age }}岁</span>
								<span class="user-right-detail">{{ record.province }}{{ record.city }}</span>
							</p>
						</div>
					</div>
					<span v-else class="user-empty">-</span>
				</template>

				<template slot="amount" slot-scope="record">
					<span>{{ record.transferAmount }}元</span>
				</template>

				<template slot="account" slot-scope="record">
					<div class="complex">
						<p>账号: {{ record.transferAccount }}</p>
						<p>姓名: {{ record.transferName }}</p>
					</div>
				</template>

				<template slot="status" slot-scope="record">
					<div class="complex">
						<span class="wait" v-if="record.transferStatus == 'WAIT'">待处理</span>
						<template v-else-if="record.transferStatus == 'PAID'">
							<span class="processing">已支付</span>
							<p class="assist" v-if="record.disposeTime">{{ record.disposeTime }}</p>
						</template>
						<template v-else-if="record.transferStatus == 'FAILD'">
							<span class="error">失败</span>
							<p class="assist" v-if="record.disposeTime">{{ record.disposeTime }}</p>
						</template>
						<span v-else>{{ record.transferStatus }}</span>
					</div>
				</template>

				<span slot="action" slot-scope="record">
					<a @click="openDetail(record)">详情</a>
					<template v-if="record.transferStatus === 'WAIT'">
						<a-divider type="vertical" />
						<a v-has="'/op/userTransferPay'" @click="openPay(record)">支付</a>
						<a-divider type="vertical" />
						<a v-has="'/op/userTransferRefuse'" @click="openRefuse(record)">拒绝</a>
					</template>
					<template v-if="record.isDispose === 'Y'">
						<a-divider type="vertical" />
						<a v-has="'/op/userTransferManualNnotify'"
							:disabled="manualNotifyId === record.id"
							@click="onManualNotify(record)"
						>
							{{ manualNotifyId === record.id ? '发送中…' : '手动通知' }}
						</a>
					</template>
				</span>
			</a-table>

			<div class="x-pagination">
				<a-pagination
					:pageSize="pageSize"
					v-model="pageIndex"
					:total="totalRow"
					@change="pageChange"
					:hideOnSinglePage="true"
					show-less-items
				/>
			</div>
		</a-card>

		<a-drawer
			title="详情"
			placement="right"
			:width="560"
			:visible="detailVisible"
			:destroy-on-close="true"
			wrap-class-name="user-transfer-detail-drawer"
			@close="closeDetail"
		>
			<a-descriptions v-if="detailRecord" :column="1" bordered size="small">
				<a-descriptions-item label="ID">{{ detailRecord.id }}</a-descriptions-item>
				<a-descriptions-item label="用户ID">{{ detailRecord.userId }}</a-descriptions-item>
				<a-descriptions-item label="支付类型">
					{{ detailRecord.transferType === 'ALIPAY' ? '支付宝' : detailRecord.transferType === 'WECHAT' ? '微信' : detailRecord.transferType }}
				</a-descriptions-item>
				<a-descriptions-item label="转账单号">{{ detailRecord.transferNo || '-' }}</a-descriptions-item>
				<a-descriptions-item label="金额(元)">{{ detailRecord.transferAmount }}</a-descriptions-item>
				<a-descriptions-item label="账号">{{ detailRecord.transferAccount }}</a-descriptions-item>
				<a-descriptions-item label="姓名">{{ detailRecord.transferName }}</a-descriptions-item>
				<a-descriptions-item label="状态">{{ statusText(detailRecord.transferStatus) }}</a-descriptions-item>
				<a-descriptions-item label="处理时间">{{ detailRecord.disposeTime || '-' }}</a-descriptions-item>
				<a-descriptions-item label="创建时间">{{ detailRecord.created }}</a-descriptions-item>
				<a-descriptions-item label="关联类型">{{ detailRecord.refType || '-' }}</a-descriptions-item>
				<a-descriptions-item label="关联ID">{{ detailRecord.refId }}</a-descriptions-item>
				<a-descriptions-item label="备注">{{ detailRecord.remark || '-' }}</a-descriptions-item>
			</a-descriptions>
		</a-drawer>

		<a-modal
			v-model="payVisible"
			title="转账"
			:footer="null"
			width="560px"
			destroyOnClose
			@cancel="onPayModalCancel"
		>
			<template v-if="payRecord">
				<a-form-model
					ref="payFormRef"
					:model="payForm"
					:label-col="{ span: 5 }"
					:wrapper-col="{ span: 17 }"
				>
					<a-form-model-item label="支付类型">
						<span class="pay-readonly">{{ payTypeLabel }}</span>
					</a-form-model-item>
					<a-form-model-item label="账户">
						<span class="pay-readonly">{{ payAccountLine }}</span>
					</a-form-model-item>
					<a-form-model-item label="金额">
						<span class="pay-readonly">{{ applyAmountLine }}</span>
					</a-form-model-item>
					<a-form-model-item label="订单号" prop="transferNo" :rules="payRules.transferNo">
						<a-input v-model="payForm.transferNo" placeholder="请输入订单号" />
					</a-form-model-item>
					<a-form-model-item label="金额" prop="payAmount" :rules="payRules.payAmount">
						<a-input v-model="payForm.payAmount" type="number" placeholder="实际转账金额" style="width: 150px;" addon-after="元" />
					</a-form-model-item>
				</a-form-model>
				<div class="pay-modal-footer">
					<a-button type="primary" :loading="payLoading" @click="payOk">提交</a-button>
				</div>
			</template>
		</a-modal>

		<a-modal
			v-model="refuseVisible"
			title="拒绝"
			:footer="null"
			width="560px"
			destroyOnClose
			@cancel="onRefuseModalCancel"
		>
			<template v-if="refuseRecord">
				<a-form-model
					ref="refuseFormRef"
					:model="refuseForm"
					:label-col="{ span: 5 }"
					:wrapper-col="{ span: 17 }"
				>
					<a-form-model-item label="支付类型">
						<span class="pay-readonly">{{ refuseTypeLabel }}</span>
					</a-form-model-item>
					<a-form-model-item label="账户">
						<span class="pay-readonly">{{ refuseAccountLine }}</span>
					</a-form-model-item>
					<a-form-model-item label="金额">
						<span class="pay-readonly">{{ refuseAmountLine }}</span>
					</a-form-model-item>
					<a-form-model-item label="原因" prop="remark" :rules="refuseRules.remark">
						<a-textarea v-model="refuseForm.remark" placeholder="请输入拒绝原因" :rows="5" />
					</a-form-model-item>
				</a-form-model>
				<div class="pay-modal-footer">
					<a-button type="primary" :loading="refuseLoading" @click="refuseOk">提交</a-button>
				</div>
			</template>
		</a-modal>
		<user-detail-drawer ref="userDetailDrawer" />
	</div>
</template>

<script>
import moment from 'moment';
import UserDetailDrawer from '@/components/UserDetailDrawer.vue';
import {
	userTransferList,
	userTransferPay,
	userTransferRefuse,
	userTransferManualNotify,
} from '@/api/op/userTransfer';

const tableColumns = [
	{ title: '#', dataIndex: 'id', width: 70 },
	{ title: '支付类型', scopedSlots: { customRender: 'transferType' }, width: 90 },
	{ title: '用户', scopedSlots: { customRender: 'user' }, width: 220 },
	{ title: '金额(元)', scopedSlots: { customRender: 'amount' }, width: 100 },
	{ title: '账户', scopedSlots: { customRender: 'account' }, width: 200 },
	{ title: '状态', scopedSlots: { customRender: 'status' }, width: 130 },
	{ title: '时间', dataIndex: 'created', width: 160 },
	{ title: '操作', scopedSlots: { customRender: 'action' }, width: 280 },
];

export default {
	components: {
		UserDetailDrawer,
	},
	data() {
		return {
			advanced: false,
			queryParams: {},
			totalRow: 0,
			tableColumns,
			tableData: [],
			tableLoading: false,
			pageSize: 20,
			pageIndex: 1,
			createTime: [],
			detailVisible: false,
			detailRecord: null,
			payVisible: false,
			payLoading: false,
			payRecord: null,
			payForm: { id: 0, transferNo: '', payAmount: '' },
			payRules: {
				transferNo: [{ required: true, message: '请输入订单号', trigger: 'blur' }],
				payAmount: [
					{ required: true, message: '请输入金额', trigger: 'blur' },
					{
						pattern: /^\d+(\.\d{1,2})?$/,
						message: '请输入正确金额（最多两位小数）',
						trigger: 'blur',
					},
				],
			},
			refuseVisible: false,
			refuseLoading: false,
			refuseRecord: null,
			refuseForm: { id: 0, remark: '' },
			refuseRules: {
				remark: [{ required: true, message: '请输入原因', trigger: 'blur' }],
			},
			manualNotifyId: null,
		};
	},
	created() {
		this.fetchTableData();
	},
	computed: {
		payTypeLabel() {
			if (!this.payRecord) return '';
			if (this.payRecord.transferType === 'ALIPAY') return '支付宝';
			if (this.payRecord.transferType === 'WECHAT') return '微信';
			return this.payRecord.transferType || '-';
		},
		payAccountLine() {
			if (!this.payRecord) return '';
			const acc = this.payRecord.transferAccount || '';
			const name = this.payRecord.transferName || '';
			if (acc && name) return `${acc} - ${name}`;
			return acc || name || '-';
		},
		applyAmountLine() {
			if (!this.payRecord) return '';
			const v = this.payRecord.transferAmount;
			return v != null && v !== '' ? `${v}元` : '-';
		},
		refuseTypeLabel() {
			if (!this.refuseRecord) return '';
			if (this.refuseRecord.transferType === 'ALIPAY') return '支付宝';
			if (this.refuseRecord.transferType === 'WECHAT') return '微信';
			return this.refuseRecord.transferType || '-';
		},
		refuseAccountLine() {
			if (!this.refuseRecord) return '';
			const acc = this.refuseRecord.transferAccount || '';
			const name = this.refuseRecord.transferName || '';
			if (acc && name) return `${acc} - ${name}`;
			return acc || name || '-';
		},
		refuseAmountLine() {
			if (!this.refuseRecord) return '';
			const v = this.refuseRecord.transferAmount;
			return v != null && v !== '' ? `${v}元` : '-';
		},
	},
	methods: {
		statusText(s) {
			if (s === 'WAIT') return '待处理';
			if (s === 'PAID') return '已支付';
			if (s === 'FAILD') return '失败';
			return s || '-';
		},
		fetchTableData() {
			this.tableLoading = true;
			this.queryParams.pageSize = this.pageSize;
			this.queryParams.page = this.pageIndex;
			userTransferList(this.queryParams)
				.then((res) => {
					if (!res.isSucceed) {
						this.$message.error(res.message || '加载失败');
						this.tableData = [];
						this.totalRow = 0;
						return;
					}
					this.totalRow = res.data.totalRow;
					this.tableData = res.data.recordList || [];
				})
				.catch(() => {
					this.$message.error('网络异常');
					this.tableData = [];
				})
				.finally(() => {
					this.tableLoading = false;
				});
		},
		onCreateTime(values) {
			if (values && values.length === 2) {
				this.queryParams.startCreateTime = moment(values[0]).unix();
				this.queryParams.endCreateTime = moment(values[1]).unix();
			} else {
				delete this.queryParams.startCreateTime;
				delete this.queryParams.endCreateTime;
			}
		},
		toggleAdvanced() {
			this.advanced = !this.advanced;
		},
		pageChange(current) {
			this.pageIndex = current;
			this.fetchTableData();
		},
		rest() {
			this.createTime = [];
			this.queryParams = {};
			this.pageIndex = 1;
			this.fetchTableData();
		},
		openUserDetail(id) {
			if (this.$refs.userDetailDrawer) {
				this.$refs.userDetailDrawer.open(id);
			}
		},
		openDetail(record) {
			this.detailRecord = { ...record };
			this.detailVisible = true;
		},
		closeDetail() {
			this.detailVisible = false;
			this.detailRecord = null;
		},
		openPay(record) {
			this.payRecord = { ...record };
			this.payForm = {
				id: record.id,
				transferNo: '',
				payAmount: record.transferAmount != null && record.transferAmount !== '' ? String(record.transferAmount) : '',
			};
			this.payVisible = true;
			this.$nextTick(() => {
				if (this.$refs.payFormRef) {
					this.$refs.payFormRef.clearValidate();
				}
			});
		},
		onPayModalCancel() {
			this.payRecord = null;
		},
		payOk() {
			this.$refs.payFormRef.validate((valid) => {
				if (!valid) return;
				this.payLoading = true;
				userTransferPay({
					id: this.payForm.id,
					transferNo: this.payForm.transferNo,
					payAmount: this.payForm.payAmount,
				})
					.then((res) => {
						if (!res.isSucceed) {
							this.$message.error(res.message || '操作失败');
							return;
						}
						this.payVisible = false;
						this.payRecord = null;
						this.$message.success('操作成功');
						this.fetchTableData();
					})
					.catch(() => {
						this.$message.error('网络异常');
					})
					.finally(() => {
						this.payLoading = false;
					});
			});
		},
		openRefuse(record) {
			this.refuseRecord = { ...record };
			this.refuseForm = { id: record.id, remark: '' };
			this.refuseVisible = true;
			this.$nextTick(() => {
				if (this.$refs.refuseFormRef) {
					this.$refs.refuseFormRef.clearValidate();
				}
			});
		},
		onRefuseModalCancel() {
			this.refuseRecord = null;
		},
		refuseOk() {
			this.$refs.refuseFormRef.validate((valid) => {
				if (!valid) return;
				this.refuseLoading = true;
				userTransferRefuse({ ...this.refuseForm })
					.then((res) => {
						if (!res.isSucceed) {
							this.$message.error(res.message || '操作失败');
							return;
						}
						this.refuseVisible = false;
						this.refuseRecord = null;
						this.$message.success('操作成功');
						this.fetchTableData();
					})
					.catch(() => {
						this.$message.error('网络异常');
					})
					.finally(() => {
						this.refuseLoading = false;
					});
			});
		},
		onManualNotify(record) {
			const self = this;
			this.$confirm({
				title: '手动通知',
				content: '将按当前记录状态再次向消息队列发送一条转账结果通知，确定发送？',
				okText: '确定',
				cancelText: '取消',
				onOk() {
					self.manualNotifyId = record.id;
					return userTransferManualNotify({ id: record.id })
						.then((res) => {
							if (!res.isSucceed) {
								self.$message.error(res.message || '发送失败');
								return;
							}
							self.$message.success('已下发通知');
						})
						.catch(() => {
							self.$message.error('网络异常');
						})
						.finally(() => {
							self.manualNotifyId = null;
						});
				},
			});
		},
	},
};
</script>

<style lang="less" scoped>
.user {
	display: flex;
	flex-direction: row;

	.user-left {
		display: flex;
		flex-direction: column;
		margin-right: 8px;
		text-align: center;

		.cover-img {
			border-radius: 4px;
			object-fit: cover;
			cursor: pointer;
		}
	}

	.user-right {
		display: flex;
		flex-direction: column;
		justify-content: space-between;

		p.first {
			margin: 0;
			.nickname {
				color: #686868;
				font-weight: bold;
			}
		}

		p.row {
			font-size: 12px;
			color: #acacac;
			margin: 0;
		}

		.user-right-detail {
			margin-right: 5px;
		}
	}
}

.user-empty {
	color: #acacac;
	font-size: 12px;
}

.complex {
	p {
		margin: 0;
	}
}

.assist {
	font-size: 12px;
	color: #acacac;
	margin-top: 4px;
	margin-bottom: 0;
}

.wait {
	color: #fa8c16;
}

.processing {
	color: #52c41a;
}

.pay-readonly {
	color: rgba(0, 0, 0, 0.85);
}

.pay-modal-footer {
	text-align: center;
	margin-top: 16px;
	padding-top: 8px;
	border-top: 1px solid #f0f0f0;
}
</style>
